import { ActionContext } from 'vuex';
import { AppState } from './types';

export default {
  setApplicationId(store: ActionContext<AppState, any>, applicationId: string): void {
    store.commit('setApplicationId', applicationId);
  }
};
